import React from 'react';
import EditStudent from './EditStudent';
import '../../../CommonCSS/SocietyCSS.css'


const EditStudentApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5> Edit Student </h5>
          </div>
        </div>
        <EditStudent/>
      </div>
    </div >
  );
};

export default EditStudentApp;
